import React from 'react'
import styles from './StoreFrontUserHeader.module.scss'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../stores/store'
import { logOut } from '../../../../stores/slices/current-user-slice'
import { useLocation, useNavigate } from 'react-router-dom'
import { ApplicationRoutes } from '../../../../routes'

type Props = {
    userName: string;
}

const StoreFrontUserHeader: React.FC<Props> = (props: Props) => {
    const { userName } = props

    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const location = useLocation();

    const onLogout = () => {
        dispatch(logOut())
        navigate('/')
    }

    const onRegister = () => {
        navigate(`/${ApplicationRoutes.LOGIN}`, { state: { route: location.pathname }})
    }

    return (
        <div className={styles.container}>
				<h6 className={styles.welcome}>Welcome</h6>
                {
                    userName ? (
                        <>
                            <h3 className={styles.userInfo}>{userName}</h3>
                            <button className={`${styles.logoutButton} standardButton`} onClick={onLogout}>Logout</button>
                        </>
                    ) : (
                        <button className={styles.signInButton} onClick={onRegister} >Sign in / Register</button>
                    )
                }
		</div>
    )
}

export default StoreFrontUserHeader